import { HISTORY_ROUTE_ANCHOR_ID } from '../components/History';
import { SPORTS_ROUTE_ANCHOR_ID } from '../components/MobileSportsRouteView';
import { HOME_ROUTE_ANCHOR_ID } from '../components/RoutesHome';
import { LIVE_ROUTE_ANCHOR_ID } from '../components/RoutesLive';
import { EXTRAS_ROUTE_ANCHOR_ID } from '../modules/missions/components/Missions/Missions';
import { type ObjectValuesUnionType } from '../utils/typing';

export const TabBarNavigationTypes = Object.freeze({
  HOME: 'HOME',
  SPORTS: 'SPORTS',
  LIVE: 'LIVE',
  BASKET: 'BASKET',
  MY_BETS: 'MY_BETS',
  EXTRAS: 'EXTRAS',
  GRIDS: 'GRIDS',
  GRIDS_HISTORY: 'GRIDS_HISTORY',
  KOH_LANTA: 'KOH_LANTA',
  GIFT_RACE: 'GIFT_RACE',
  MONOPOLY: 'MONOPOLY',
  BOOM: 'BOOM',
});

export type TabBarNavigationType = ObjectValuesUnionType<typeof TabBarNavigationTypes>;

export const TabBarAnchorIdsByNavigationTypes = Object.freeze({
  [TabBarNavigationTypes.HOME]: HOME_ROUTE_ANCHOR_ID,
  [TabBarNavigationTypes.SPORTS]: SPORTS_ROUTE_ANCHOR_ID,
  [TabBarNavigationTypes.LIVE]: LIVE_ROUTE_ANCHOR_ID,
  [TabBarNavigationTypes.MY_BETS]: HISTORY_ROUTE_ANCHOR_ID,
  [TabBarNavigationTypes.EXTRAS]: EXTRAS_ROUTE_ANCHOR_ID,
});
